$(document).on('click', '[data-click-target]', function() {
  var target = $(this).data('click-target');
  window.location = target;
});
